import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { tenantCompanyPhoneSelector } from '../../../../customer/redux/common/common.selectors';
import { SwagPhoneComponent } from './swag-phone';
const mapStateToProps = createStructuredSelector({
  tenantCompanyPhone: tenantCompanyPhoneSelector
});
export const SwagPhone = connect(mapStateToProps, null)(SwagPhoneComponent);